import PropTypes from "prop-types";
import ReactTimeAgo from "react-timeago";

export default function TimeAgo({ date, formatter }) {
  if (formatter) return <ReactTimeAgo date={date} formatter={formatter} />;
  return <ReactTimeAgo date={date} />;
}

TimeAgo.propTypes = {
  date: PropTypes.string.isRequired,
  formatter: PropTypes.func,
};

TimeAgo.defaultProps = {
  formatter: null,
};
